/* eslint-disable */

/**
 * Helper class to structure the topics in different parts, needed when generating the documents on server.
 * The document parts can be one of the following:
 * Html     : Raw html that will be inserted in the document
 * Container: Contains elements that we want to keep on the same page in the document
 * Image    : Contains an image url that will be added to the document
 * PageBreak: Will add a page break at specific place
 */
export class DocumentGenerateHelper {

  constructor() { }

  getPDFDocumentParts(locale) {
    let div = $('html').clone()

    $('.filtered-out', div).remove()
    $('.error-msg', div).remove()

    this.setFontAndEncoding(div, locale)

    // Remove script tags
    let scripts = div[0].getElementsByTagName('script')
    let i = scripts.length
    while (i--) {
      scripts[i].parentNode.removeChild(scripts[i])
    }

    // Remove iframes
    let iframes = div[0].getElementsByTagName('iframe')
    i = iframes.length
    while (i--) {
      iframes[i].parentNode.removeChild(iframes[i])
    }

    $('a, link', div).not('[href^="http"],[href^="https"],[href^="mailto:"],[href^="#"]').each(function() {
        $(this).attr('href', function(index, value) {
            return window.location.origin + value;
        });
    });

    $('img', div).not('[src^="http"],[src^="https"]').each(function() {
        $(this).attr('src', function(index, value) {
            return window.location.origin + value;
        });
    });

    // Avoid page break in footer
    $('.topic-footnotes', div).css('page-break-inside: avoid;')

    // Avoid page break after sub titles
    $('h2,h3,h4,h5', div).each((index, element) => {
      const sibling = $('+ *', element);
      if (sibling && sibling.length > 0) {
        $(element).replaceWith(function() {
          return `<div style="page-break-inside: avoid;page-break-before: auto;page-break-after: auto;display:block;">
                    ${element.outerHTML}
                    ${sibling.get(0).outerHTML}
                  </div>`
        })
        sibling.remove();
      }
    })

    $('.validity', div).each((i, validityWrapper) => {
      const vWrapper = $(validityWrapper);
      vWrapper.removeClass('validity');
    })

    const html = div.html();

    return [this.createDocumentPart(html, false)]
  }

  setFontAndEncoding(div, locale) {
    // We need other encoding for Chinese
    if (locale === 'zh-cn' || locale === 'zh-tw') {
      var metaContentType = $("meta[http-equiv='Content-type']", div);
      metaContentType.attr('content', 'text/html; charset=ISO-8859-1')
    }
    
    // Use special fonts for some languages
    let font = ''

    if (locale === 'ko-kr') {
      font = 'NotoSansKR'
    }
    else if (locale === 'ja-jp') {
      font = 'NotoSansJP'
    }
    else if (locale === 'zh-cn' || locale === 'zh-tw') {
      font = 'NotoSansCN'
    }

    if (font.length > 0) {
      $('h1, h2, h3, h4, h5, span, p, div, b, a, li', div).css('font-family', font)
    }
  }

  getWordDocumentParts() {
    var container = $(".page-content .main-container").clone()
    let breadCrumb = $('.breadcrumb > span').clone()

    this.removeUnwantedElements(container)
    this.setElementStyles(container, breadCrumb)
    this.fixLists(container)
    this.setAbsolutePaths(container)

    // Set all table to full width
    $('table', container).attr('width', '100%')
    $('table', container).css('width', '100%')

    $('table td', container).css({
      'border': '1px solid #e4e4e4',
      'padding': '6pt'
    })

    this.specialTextsToTable(container)

    // Fix footnotes. Replace ul with div
    $('.topic-footnotes', container).each((index, element) => {
      let $element = $(element)
      $('li', element).each((i, item) => {
        let $item = $(item)
        $element.append(`<div style="color: #9a9b9d">${$item.html()}</div>`)
      })

      $('ul', element).remove()
    })

    // Show video thumbnails
    $('.multimedia video', container).remove()
    $('.multimedia .video-thumbnail', container).css({
      'display': 'block',
      'height': 'auto',
      'width': '100%'
    })
    
    // Add news tag to all new child elements so that we can select them when html has been flattened
    $('.news *', container).addClass("news")

    // Do not nest images to be able to split html sent to server
    $('.figure', container).each((i, figure) => {
      $(figure).before($('img', figure))
    })
    
    // Set gearbox class on all child elements
    $('[data-gearbox]:not(.article-ref) *:not(.segment)', container).addClass("gearbox")
    
    // Decrease number of nested elements
     $('.topic-article', container).each((i, article) => {
      const articleLead = $('.article-lead', article)
      const topicGearbox =  $('.gearbox-title--topic', article)

      if (articleLead && articleLead.length) {
        articleLead.after($('.segment', article))
        articleLead.after(topicGearbox)
      }
      else {
        topicGearbox.after($('.segment', article))
      }
     })
    // this.fixGearbox(container)

    $('.topic-article-wrapper', container).each((i, wrapper) => {
     let articleRef = $('.article-ref', wrapper)
     articleRef.addClass('topic-article')
     $(wrapper).before(articleRef)
     $(wrapper).remove()
    })

    $('.subsegment', container).each((i, subSegment) => {
      // Remove subsegment if not news tag or gearbox. Alwasy remove if containing image
      if (!($(subSegment).hasClass('news') || $(subSegment).hasClass('gearbox'))
          || $('img', subSegment).length > 0) {
        $(subSegment).before($('> *', subSegment))
        $(subSegment).remove()
      }
    })

    $('.segment:not(.gearbox-table)', container).each((i, segment) => {
     $('> *', segment).first().addClass('first-segment-child') // Used when creating news tables
     $(segment).before($('> *', segment))
     $(segment).remove()
    })

    //////////////////////////////////////

    // Remove unnecessary validity wrappers
    $('.validity', container).each((i, validityWrapper) => {
      $(validityWrapper).before($('> *', validityWrapper))
      $(validityWrapper).remove()
    })

    // Move all elements outside topic-article
    $('.topic-article', container).each((i, article) => {
      $(article).before($('> *', article))
      $(article).remove()
    })

    this.fixNews(container)
    this.fixGearbox(container)

    // Avoid page break inside footer
    $('.topic-footnotes', container).css('page-break-inside: avoid;')

    // Avoid page break after titles
    $('h2,h3,h4,h5', container).each((index, element) => {
      // Skip if title was below article lead.
      if ($(element).prev('*').hasClass("article-lead")) {
        return;
      }
      var sibling = $('+ *', element);
      if (sibling && sibling.length > 0) {
        $(element).replaceWith(function() {
          return `<div style="page-break-inside: avoid;">
                    ${element.outerHTML}
                    ${sibling.get(0).outerHTML}
                  </div>`
        })
        sibling.remove();
      }
    })

    let documentParts = []

    // Get all elments
    let allTopElements = $('> *', container)
    // let firstH1 = true
    let html = ''

    // Create a list of document parts that is sent to server
    for(let i = 0; i < allTopElements.length; i++) {
      let topElement = $(allTopElements[i])

      html = this.createDocumentParts(topElement, html, documentParts)
    }

    if (html.length > 0) {
      documentParts.push(this.createDocumentPart(html, false))
    }
    
    // Insert breadcrumb as first document part
    documentParts.unshift(this.createDocumentPart(breadCrumb.html(), false))

    return documentParts;
  }

  fixGearbox(container) {
    // Create table with left border to be able to render it in Word

    let borderColor = '#dedede'

    $('.gearbox-title--topic', container).each((i, e) => {
      $(e).replaceWith(() => {
        return `<table class="gearbox-table segment" style="width:100%; page-break-inside: avoid;">
                  <tbody>
                    <tr>
                      <td style="border:1px solid ${borderColor}; page-break-inside: avoid; padding:10pt;">
                        <div style="page-break-inside: avoid; display: block; line-height:25px;">
                          ${e.outerHTML}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table><br>`
      })
    })
    
    // Remove nested gearbox classes
    $('.gearbox .gearbox', container).removeClass('gearbox');

    // Do not select image since we need them outside of table to be able to create the word document.
    // The image will "cut" the table in two parts
    let firstTag = $($('.gearbox:not(img,.figure)', container)[0])
    while (firstTag.length > 0) {
      firstTag.removeClass('gearbox')
      let gearboxHtml = firstTag[0].outerHTML;

      // Retrieve all adjecent elements with gearbox class and create a table
      let nextElement = firstTag.next()
      while(nextElement.length > 0 && !nextElement.is('img') && !nextElement.hasClass('.figure') && nextElement.hasClass('gearbox')) {
        nextElement.removeClass('gearbox')
        gearboxHtml += nextElement[0].outerHTML
        let temp = nextElement.next()
        nextElement.remove()
        nextElement = temp
      }

      firstTag.replaceWith(function () {
        return `<br><table class="gearbox-table segment" style="width:100%; page-break-inside: avoid;">
                  <tbody>
                    <tr>
                      <td style="border:1px solid ${borderColor}; page-break-inside: avoid; padding:10pt;">
                        <div style="page-break-inside: avoid; display: block; line-height:25px;">
                          ${gearboxHtml}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table><br>`
      })

      firstTag = $($('.gearbox:not(img,.figure)', container)[0])
    }

    // Create table header of gearbox validity header
    $('.gearbox-table > tbody', container).each((i, e) => {
      let tableBody = $(e)
      $('.segment', tableBody).removeClass('segment')

      $('> tr', tableBody).each(function() {
        let row = $(this)
        if ($('> td > div', row).html().replace(/\s/g,'').length === 0) {
          row.remove();
        }
      })

      let gearboxTitle = $('.gearbox-title', tableBody)

      if (gearboxTitle.length > 0) {
        gearboxTitle.remove()

        tableBody.prepend($(
          `<tr>
              <th style="text-align: left; width:100%; background-color: ${borderColor}; page-break-inside: avoid; padding:10pt;">
                <div style="page-break-inside: avoid; display: block; line-height:25px;">
                  ${gearboxTitle[0].outerHTML}
                </div>
              </th>
            </tr>`
        ))
      }

      // Remove all empty rows in table
      $('> tr', tableBody).each((index, element) => {
        // Remove all new lines and white space
        var rowText = $(element).text().trim().replace(/(\r\n|\n|\r)/gm," ").trim()
        if (rowText.length === 0) {
          $(element).remove()
        }
      })
    });
  }

  fixNews(container) {
     // Only allow one level of news class since it will be wrappe din table
     $('.news .news', container).removeClass('news');
     
     // Do not select image since we need them outside of table to be able to create the word document.
     // The image will "cut" the table in two parts
     let firstNewsTag = $($('.news:not(img,.figure)', container)[0])
     while (firstNewsTag.length > 0) {
       firstNewsTag.removeClass('news')
       let newsHtml = firstNewsTag[0].outerHTML;
 
       // Retrieve all adjecent elements with news class and create a table
       let nextElement = firstNewsTag.next()
       while(nextElement.length > 0 &&
             !nextElement.is('img') &&
             !nextElement.hasClass('first-segment-child') && // The first child in new segment (segment wrapper has been removed)
             !nextElement.hasClass('figure') && 
             !(nextElement.hasClass('subsegment') && !nextElement.hasClass('gearbox')) && 
             nextElement.hasClass('news')) {

         nextElement.removeClass('news')
         newsHtml += nextElement[0].outerHTML
         let temp = nextElement.next()
         nextElement.remove()
         nextElement = temp
       }
 
       firstNewsTag.replaceWith(function () {
         let $this = $(this)
         let borderColor = '#c8e691'
         
         let isListItem = $this.is('li')
        
         let tableStyle = `width:100%; page-break-inside: avoid;${isListItem ? 'margin-left: -28pt;' : ''}`
         let replacement = 
                `<table class="segment" style="${tableStyle}">
                   <tbody>
                     <tr>
                       <td style="border:1px solid #ffffff; border-left: 3pt solid ${borderColor}; page-break-inside: avoid; ">
                         <div style="page-break-inside: avoid; display: block; line-height:25px; padding-left:10pt;margin-left:10pt;font-family:'Arial';">
                           ${newsHtml}
                         </div>
                       </td>
                     </tr>
                   </tbody>
                 </table>`;

          // Do not add spacing to li elements
          if (!isListItem) {
            replacement = `<br>${replacement}<br>`
          }

          return replacement;
       })
 
       firstNewsTag = $($('.news:not(img,.figure)', container)[0])
     }
   }

  specialTextsToTable(container) {
    // Style "special texts"
    $('.warning, .caution, .note, .important', container).replaceWith(function () {
      let $this = $(this)

      $('h2', $this).replaceWith(function() {return `<p style="margin-bottom:4px;font-size:18px;font-weight:bold;">${ $(this).html() }</p>`})
      $('p', $this).css('margin-bottom:0px')

      let borderColor = '';
      if ($this.hasClass('warning')) {
        borderColor = '#e47720'
      }
      if ($this.hasClass('important')) {
        borderColor = '#ffca0d'
      }
      if ($this.hasClass('note')) {
        borderColor = '#bed6e6'
      }
      if ($this.hasClass('caution')) {
        borderColor = '#bed6e6'
      }
      return `<table style="width:100%; page-break-inside: avoid;">
                <tbody>
                  <tr>
                    <td style="border:1px solid #ffffff; border-left: 6px solid ${borderColor}; page-break-inside: avoid; padding:10pt;background-color:#f4f4f4;">
                      <div style="page-break-inside: avoid; display: block; line-height:25px;">
                        ${$this.html()}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>`;
    })
  }

  fixLists(container) {
    // Fix number lists
    $('.legentry', container).each((index, element) => {
      let $element = $(element)
      let number = $('.sy', $element)
      let desc = $('.desc', $element)

      let descLiteral = $('.literal', desc)
      descLiteral.before(descLiteral.html())
      descLiteral.remove()

      desc.html(`<div>${number.html()} ${desc.html()}</div>`)
      number.remove()
    })
  }

  removeUnwantedElements(container) {
    // Remove elements that is excluded in print
    $('.print-btn', container).remove()
    $('.topic-missing-warning', container).remove()
    $('.AddToPrintButton', container).remove()
    $('.back-link', container).remove()
    $('.header', container).remove()
    $('.feedback-container, #_hj_feedback_container, #_hj_poll_container', container).remove()
    $('.filtered-out', container).remove()
    $('.error-msg', container).remove()
    $('.fn', container).remove()
    $('span.literal', container).replaceWith(function () {
      return `${$(this).text()} `
    })
  }

  setElementStyles(container, breadCrumb) {
    container.css('font-family',  'Arial')
    $('h1, h2, h3, h4, div, span, p, li', container).css('font-family', 'Arial')

    breadCrumb.css('font-size', '20px')

    // Style article lead and add spacing
    let lead = $('.article-lead p', container);
    lead.css({
      'font-size' : '14pt'
    })

    lead.parent().append('<div>&nbsp;</div>')

    $('.segment > h2', container).css({
      'text-decoration': 'underline',
      'font-size': '16pt'
    })
  }

  setAbsolutePaths(container) {
    // Set absolute urls
    $('a, link', container).not('[href^="http"],[href^="https"],[href^="mailto:"],[href^="#"]').each(function() {
        $(this).attr('href', function(index, value) {
            return window.location.origin + value
        });
    });

    // Set absolute urls
    $('img', container).not('[src^="http"],[src^="https"]').each(function() {
        $(this).attr('src', function(index, value) {
            return window.location.origin + value
        });
    });
  }

  createDocumentParts(topElement, html, documentParts) {
    // If image is wrapped in a container, create multiple document parts
    // This is needed to be able to set page breaks correctly
    if ($('> img', topElement).length > 0) {
      if (html.length > 0) {
        documentParts.push(this.createDocumentPart(html, false))
        html = ''
      }
      var childElements = $('> *', topElement)
      var childParts = []
      for(let i = 0; i < childElements.length; i++) {
        html = this.createDocumentParts($(childElements[i]), html, childParts)
      }
      documentParts.push(this.createChildParts(childParts))
      html = ''
    }
    else if (topElement.is('img')) {
      documentParts.push(this.createDocumentPart(html, false))
      documentParts.push(this.createDocumentPart(`${topElement.attr('src')}`, true, topElement.hasClass("news"), topElement.hasClass("gearbox")))
      html = ''
    }
    else if (topElement.is('h1')) {
      // Do not add page break on first h1 element
      if (documentParts.length === 0 && html.length === 0) {
        html += topElement.get(0).outerHTML
      }
      else {
        documentParts.push(this.createDocumentPart(html, false))
        documentParts.push(this.createPageBreak());
        html = topElement.get(0).outerHTML
      }
    }
    else {
      html += topElement.get(0).outerHTML
    }

    return html
  }
  createPageBreak() {
    return { typeOfContent: "PageBreak" }
  }
  createChildParts(children) {
    return { typeOfContent: "Container", children: children }
  }
  createDocumentPart(content, isImage, isNews, isGearbox) {
    return { typeOfContent: (isImage ? "Image" : "Html"), content: content.replace(new RegExp('&quot;', 'g'), '"'), news: isNews, gearbox: isGearbox }
  }
}